import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Car, Package, ChevronRight, Clock } from 'lucide-react';

const RideHistorySummary = ({ stats }) => {
  const navigate = useNavigate();

  const displayStats = {
    totalRides: stats?.totalRides ?? 0,
    totalDeliveries: stats?.totalDeliveries ?? 0,
    totalSpent: stats?.totalSpent ?? 0,
    lastActivity: stats?.lastActivity ?? null,
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-[#1a365d]" />
          <h3 className="font-semibold text-[#1a365d]">Activity Summary</h3>
        </div>
        <button
          onClick={() => navigate('/order-tracking-screen')}
          className="flex items-center gap-1 text-xs text-[#2d5a87] font-medium hover:text-[#1a365d] transition-colors"
        >
          View History <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-3 gap-3">
          <div className="bg-[#1a365d]/5 rounded-xl p-3.5 text-center">
            <div className="w-8 h-8 bg-[#1a365d]/10 rounded-lg flex items-center justify-center mx-auto mb-2">
              <Car className="w-4 h-4 text-[#1a365d]" />
            </div>
            <p className="text-2xl font-bold text-[#1a365d]">{displayStats?.totalRides}</p>
            <p className="text-xs text-slate-500 mt-0.5">Rides</p>
          </div>
          <div className="bg-[#ffd700]/10 rounded-xl p-3.5 text-center">
            <div className="w-8 h-8 bg-[#ffd700]/20 rounded-lg flex items-center justify-center mx-auto mb-2">
              <Package className="w-4 h-4 text-[#d97706]" />
            </div>
            <p className="text-2xl font-bold text-[#1a365d]">{displayStats?.totalDeliveries}</p>
            <p className="text-xs text-slate-500 mt-0.5">Deliveries</p>
          </div>
          <div className="bg-green-50 rounded-xl p-3.5 text-center">
            <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-2">
              <span className="text-xs font-bold text-green-700">KSh</span>
            </div>
            <p className="text-2xl font-bold text-[#1a365d]">{displayStats?.totalSpent?.toLocaleString()}</p>
            <p className="text-xs text-slate-500 mt-0.5">Spent</p>
          </div>
        </div>
        {displayStats?.lastActivity && (
          <p className="text-xs text-slate-400 text-center mt-3">
            Last activity: {new Date(displayStats.lastActivity)?.toLocaleDateString()}
          </p>
        )}
      </div>
    </div>
  );
};

export default RideHistorySummary;
